// custom code start
(function () {
  if (window.Tracking && window.Tracking.init && window.Tracking.init.auth) return;
  var Tracking = window.Tracking || (window.Tracking = {});
  Tracking.init = Tracking.init || {};
  Tracking.init.auth = true;

  // login/sign_up tema tarafında, oturum başına bir kez atılır.
  // Yeni customer accounts auth ekranı tema dışı olduğu için "giriş anı" değil,
  // "girişli oturumun ilk sayfası" yakalanır. Social login yok; method her zaman 'email'.
  var SESSION_FLAG = 'tracking:authFired';
  var SIGNUP_MAX_AGE_SECONDS = 30 * 60; // created_at son 30 dk içindeyse sign_up, değilse login

  function push(payload) {
    if (typeof Tracking.push === 'function') {
      Tracking.push(payload);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);
    }
  }

  var node = document.getElementById('auth-candidate');
  if (!node || !node.textContent) return;

  var data;
  try {
    data = JSON.parse(node.textContent);
  } catch (e) {
    return;
  }
  if (!data || !data.shopify_customer_id) return;

  var fired = null;
  try {
    fired = sessionStorage.getItem(SESSION_FLAG);
  } catch (e) {}
  if (fired) return;

  var age = Number(data.created_seconds_ago);
  var isSignup = isFinite(age) && age >= 0 && age <= SIGNUP_MAX_AGE_SECONDS;

  var event = {
    event: isSignup ? 'sign_up' : 'login',
    method: 'email',
  };
  if (data.user_id) event.user_id = data.user_id;
  if (data.shopify_customer_id) event.shopify_customer_id = data.shopify_customer_id;
  push(event);

  try {
    sessionStorage.setItem(SESSION_FLAG, event.event);
  } catch (e) {}
})();
// custom code end
